import { Injectable } from '@nestjs/common';
import { EntityRepository, Repository } from 'typeorm';
import { EmployeeDetails } from '../employee-details.entity';

@Injectable()
@EntityRepository(EmployeeDetails)
export class EmployeeRepo extends Repository<EmployeeDetails> {

    constructor() {
        super();
    }

    async getExcutiveEmployeeCode(): Promise<any> {
        const query = this.createQueryBuilder('')
            .select(` employee_id, employee_code as employeeCode, employee_name, department_id `)
            .where(` employee_type = "Salaried Form"`);
        query.groupBy(` employee_code`)
        query.orderBy(` created_at`, 'DESC')
        return await query.getRawOne();
    }

    async getWorkerEmployeeCode(): Promise<any> {
        const query = this.createQueryBuilder('')
            .select(` employee_id, employee_code as employeeCode, employee_name, department_id `)
            .where(` employee_type = "Labour Form"`);
        query.groupBy(` employee_code`)
        query.orderBy(` created_at`, 'DESC')
        return await query.getRawOne();
    }
}